
import { CompanyReportAdminTranslation } from 'app/area/company-reports-administration/constants';
import { CompanyReportAccessData } from 'app/types-shared';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from './actions';

export function useActionCreators() {
  const dispatch = useDispatch();
  return useMemo(() =>
    bindActionCreators(actionCreators, dispatch), [dispatch]
  );
}

export function useTemplateFileHandlers(companyReportId: number, translation: CompanyReportAdminTranslation,
  companyReportAccess: CompanyReportAccessData, callback: () => void) {
  const {
    updateTemplate,
    downloadTemplate
  } = useActionCreators();

  const hasTemplateRights = companyReportAccess.manageReportTemplates;

  const handleUploadTemplate = useCallback((file: File) => {
    updateTemplate(companyReportId, file, translation, hasTemplateRights, callback);
  }, [companyReportId]);

  const handleDownloadTemplate = useCallback(() => {
    downloadTemplate(companyReportId, 'template.xlsm', translation, hasTemplateRights);
  }, [companyReportId]);

  return {
    handleUploadTemplate,
    handleDownloadTemplate
  };
}
